export default __webpack_public_path__ + "static/media/adamant-logo.b6bedaa1.svg";